import useProject from 'hooks/useProject'
import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { DOCUMENT_BASE, HUB_BASE } from 'routes'
import { getQueryParameter } from 'helpers/utils'

const Hub: React.FC = () => {
  const { project } = useProject()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!project.publicId) return

    const openSearch = getQueryParameter('openSearch') === 'true'
    const base = project.defaultProcessId
      ? `${HUB_BASE}${project.publicId}${DOCUMENT_BASE}${project.defaultProcessId}`
      : `${HUB_BASE}${project.publicId}/settings`

    const target = openSearch ? `${base}?openSearch=true` : base
    const current = `${location.pathname}${location.search}`

    // Avoid re-navigation loops if we're already there
    if (current !== target) {
      // Replace instead of push to avoid adding an extra history entry
      // Forward router state (e.g. a just-created hub's homepage opening in edit mode)
      navigate(target, { replace: true, state: location.state })
    }
  }, [project.publicId, project.defaultProcessId])

  return <div />
}

export default Hub
